import { AcademyMockApi } from 'app/helpers/mock-api/apps/academy/api';
import { ActivitiesMockApi } from 'app/helpers/mock-api/pages/activities/api';
import { AnalyticsMockApi } from 'app/helpers/mock-api/dashboards/analytics/api';
import { AuthMockApi } from 'app/helpers/mock-api/common/auth/api';
import { ChatMockApi } from 'app/helpers/mock-api/apps/chat/api';
import { ContactsMockApi } from 'app/helpers/mock-api/apps/contacts/api';
import { CryptoMockApi } from 'app/helpers/mock-api/dashboards/crypto/api';
import { ECommerceInventoryMockApi } from 'app/helpers/mock-api/apps/ecommerce/inventory/api';
import { FileManagerMockApi } from 'app/helpers/mock-api/apps/file-manager/api';
import { FinanceMockApi } from 'app/helpers/mock-api/dashboards/finance/api';
import { HelpCenterMockApi } from 'app/helpers/mock-api/apps/help-center/api';
import { IconsMockApi } from 'app/helpers/mock-api/ui/icons/api';
import { MailboxMockApi } from 'app/helpers/mock-api/apps/mailbox/api';
import { MessagesMockApi } from 'app/helpers/mock-api/common/messages/api';
import { NavigationMockApi } from 'app/helpers/mock-api/common/navigation/api';
import { NotesMockApi } from 'app/helpers/mock-api/apps/notes/api';
import { NotificationsMockApi } from 'app/helpers/mock-api/common/notifications/api';
import { ProjectMockApi } from 'app/helpers/mock-api/dashboards/project/api';
import { SearchMockApi } from 'app/helpers/mock-api/common/search/api';
import { ScrumboardMockApi } from 'app/helpers/mock-api/apps/scrumboard/api';
import { ShortcutsMockApi } from 'app/helpers/mock-api/common/shortcuts/api';
import { TasksMockApi } from 'app/helpers/mock-api/apps/tasks/api';
import { UserMockApi } from 'app/helpers/mock-api/common/user/api';

export const mockApiServices = [
    AcademyMockApi,
    ActivitiesMockApi,
    AnalyticsMockApi,
    AuthMockApi,
    ChatMockApi,
    ContactsMockApi,
    CryptoMockApi,
    ECommerceInventoryMockApi,
    FileManagerMockApi,
    FinanceMockApi,
    HelpCenterMockApi,
    IconsMockApi,
    MailboxMockApi,
    MessagesMockApi,
    NavigationMockApi,
    NotesMockApi,
    NotificationsMockApi,
    ProjectMockApi,
    SearchMockApi,
    ScrumboardMockApi,
    ShortcutsMockApi,
    TasksMockApi,
    UserMockApi
];
